import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IdEntryPage from './page';
import { getStoredLookupToken, lookupMileage, LookupNotFoundError, setStoredLookupToken } from '@/lib/api';

/**
 * Entry point (`/`). There is no login anymore — a learner just types their
 * own ID once. That ID is sent as a POST body (never a query string) to
 * mileage's lookup endpoint, which returns a short-lived signed
 * `lookup_token`. Only that token — never the raw ID — is stored
 * (sessionStorage, so a refresh on `/mileage` keeps working) before
 * navigating to `/mileage`, which uses the token for everything else.
 */
export default function IdEntryPreview() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [focusedField, setFocusedField] = useState(false);

  useEffect(() => {
    if (getStoredLookupToken()) {
      navigate('/mileage', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = userId.trim();
    if (!trimmed) {
      setErrorMsg('아이디를 입력해주세요.');
      return;
    }

    setErrorMsg('');
    setIsLoading(true);
    try {
      const result = await lookupMileage(trimmed);
      setStoredLookupToken(result.lookup_token);
      navigate('/mileage');
    } catch (error) {
      if (error instanceof LookupNotFoundError) {
        setErrorMsg('일치하는 아이디를 찾을 수 없습니다. 다시 확인해주세요.');
      } else {
        setErrorMsg('마일리지 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.');
      }
      setIsLoading(false);
    }
  };

  return (
    <IdEntryPage
      userId={userId}
      onUserIdChange={setUserId}
      isLoading={isLoading}
      errorMsg={errorMsg}
      focusedField={focusedField}
      onFocusChange={setFocusedField}
      onSubmit={handleSubmit}
    />
  );
}
